// First import: Zod must be jitless before any module builds a schema (CSP without 'unsafe-eval').
import './zod-config';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import App from './App';
import { ThemeProvider } from './providers/ThemeProvider';
import './index.css';
import './services/i18n';
import './utils/web-vitals'; // Initialize web vitals monitoring

// Validate required environment variables (OIDC configuration)
const requiredEnvVars = [
  'VITE_AUTH_AUTHORITY',
  'VITE_OIDC_ISSUER',
  'VITE_API_URL',
  'VITE_REDIRECT_URI',
  'VITE_AUTH_DOMAIN',
  'VITE_LOGIN_DOMAIN'
];

const missingVars = requiredEnvVars.filter(varName => !import.meta.env[varName]);

if (missingVars.length > 0) {
  console.error('❌ Missing required environment variables:', missingVars);
  if (import.meta.env.PROD) {
    throw new Error(`Missing required environment variables: ${missingVars.join(', ')}`);
  } else {
    console.warn('⚠️  Running in development mode with missing environment variables. The app may not work correctly.');
  }
}

try {
  const rootElement = document.getElementById('root');
  if (rootElement) {
    const root = ReactDOM.createRoot(rootElement);
    root.render(
      <React.StrictMode>
        <ThemeProvider>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </ThemeProvider>
      </React.StrictMode>
    );
  } else {
    console.error('=== ROOT ELEMENT NOT FOUND ===');
  }
} catch (error) {
  console.error('=== ERROR RENDERING REACT APP ===', error);
}
